module.exports = __webpack_public_path__ + "img/workbench_icon2.40052eb3.svg";